module.exports = __webpack_public_path__ + "assets/img/activity-time-f945880b.png";